import React from "react"
import Search from "../components/home/search"
import { Subheader } from "../components/home/subheader"

export const Home = () => (
    <>
        <Subheader />
        <Search />
    </>
)